export default class CoreService {}
